export default class CoreService {}
